// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"061b4a45","713":"428b445c"}[chunkId] + ".chunk.js";
};